module.exports = __webpack_public_path__ + "static/media/bg-pattern.8efb1209.png";